<template>
	<popup title="Are you sure you'd like to delete this automation?" small class="delete-automation-popup" @close="closePopup">
		<template v-slot:actions>
			<v-button label="Delete automation" red border @click="deleteAutomation" :loading="deleting" />
			<v-button label="Keep automation" @click="closePopup" />
		</template>
	</popup>
</template>

<script>
import API from "@/api"
import Popup from "@/components/base/popup";
import VButton from "@/components/base/v-button";

export default {
    name: "delete-automation-popup",
	components: {VButton, Popup},
	props:['automation'],
    mixins: [API],
    data() {
        return {
					deleting:false,
        }
    },
    methods: {
        closePopup() {
            this.$emit('close')
        },
        async deleteAutomation() {
					try {
						this.deleting = true;
						let r = await this.api.globalAutomations.delete(this.automation.id)
						if (r && r.error) {
							throw r.error
						}
						this.$info('','Automation deleted')
						this.$emit("done", this.automation);
					} catch (e) {
						this.$error(e)
					} finally {
						this.deleting = false;
					}
        },
    },
}
</script>

<style lang="scss" scoped>
.delete-automation-popup {

}
</style>
